export function CreateSenderIcon() {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      
      viewBox="0 0 16 16"
    >
      <path
      className='neededFill'
        fill="#9197B3"
        fillRule="evenodd"
        d="M15.406 3.413a.572.572 0 01-.074.72L8.325 11.14a.57.57 0 01-.26.149l-2.918.762a.573.573 0 01-.698-.697l.762-2.92a.593.593 0 01.123-.237l7.034-7.03a.571.571 0 01.808 0l2.156 2.157a.573.573 0 01.074.09zm-1.286.315L12.772 2.38 6.278 8.874l-.476 1.824 1.824-.476 6.494-6.494z"
        clipRule="evenodd"
      ></path>
      <path
      className='neededFill'
        fill="#9197B3"
        d="M14.023 12.367c.209-1.782.275-3.577.2-5.367a.306.306 0 01.088-.23l.75-.75a.151.151 0 01.258.097 35.012 35.012 0 01-.16 6.382 3.347 3.347 0 01-2.952 2.922 36.387 36.387 0 01-8.018 0A3.347 3.347 0 011.237 12.5a35.008 35.008 0 010-8.134 3.347 3.347 0 012.952-2.922 36.4 36.4 0 016.09-.162c.132.008.191.166.098.259l-.756.756a.306.306 0 01-.227.09 35.192 35.192 0 00-5.077.194 2.203 2.203 0 00-1.944 1.918 33.865 33.865 0 000 7.868 2.203 2.203 0 001.944 1.918 35.24 35.24 0 007.763 0 2.203 2.203 0 001.943-1.918z"
      ></path>
    </svg>
    );
  }